import {Component} from '@angular/core';
import {buildGermanDate, datum} from "../../util/date-utils";


@Component({
  templateUrl: 'tests.html'
})
export class TestsPage {

  count : number;
  countSuccess : number;
  log : string;

  runTests() {
    this.count = 0;
    this.countSuccess = 0;
    this.log = "";
    let ref = datum(5, 3, 2017);

    this.assertEquals("", buildGermanDate("", ref, ""));
    this.assertEquals("01.03.2017", buildGermanDate("1", ref, "back"));
    this.assertEquals("01.04.2017", buildGermanDate("1", ref, "forward"));
    this.assertEquals("01.03.2017", buildGermanDate("1.", ref, "back"));
    this.assertEquals("01.04.2016", buildGermanDate("1.4", ref, "back"));
    this.assertEquals("01.04.2017", buildGermanDate("1.4", ref, "forward"));
    this.assertEquals("01.04.2013", buildGermanDate("1.4.13", ref, "back"));
    this.assertEquals("01.04.2113", buildGermanDate("1.4.13", ref, "forward"));
    this.assertEquals("01.04.2013", buildGermanDate("1.4.2013", ref, ""));

    this.assertEquals("", buildGermanDate("31", ref, "back")); //es gibt keinen 31.2., deswegen Fehler
    this.assertEquals("", buildGermanDate("29", ref, "back")); //es gibt 2017 auch keinen 29.2., deswegen Fehler
    this.assertEquals("28.02.2017", buildGermanDate("28", ref, "back"));
    this.assertEquals("31.12.2016", buildGermanDate("3112", ref, "back"));
    this.assertEquals("31.12.2015", buildGermanDate("311215", ref, "back"));
    this.assertEquals("31.12.1915", buildGermanDate("31121915", ref, ""));

    this.log += "\n" + this.count + " Tests ausgeführt, davon " + this.countSuccess + " erfolgreich";
    return this.log;
  }

  assertEquals(expected: string, actual: string) {
    this.count++;
    if (expected != actual)
      this.log += "Fehler bei Test " + this.count + ": Erwartet \"" + expected + "\" aber ist \"" + actual + "\"\n";
    else
      this.countSuccess++;
  }

}



// WEBPACK FOOTER //
// ./src/pages/tests/tests.ts